import { z } from 'zod';
import { documentStorageSchema } from './document-storage.js';
/**
 * Respaldo de los documentos: un bucket de la entidad, compatible con S3, donde queda una copia de cada archivo del
 * almacenamiento principal (el que provee la plataforma). Solo agrega: lo que se borra del principal (una imagen de
 * marca reemplazada) sigue en el respaldo, así que las llaves no necesitan permiso de borrar. La retención WORM del
 * principal se copia: con Object Lock en el bucket, el expediente queda protegido en los dos lados.
 */
export const backupStorageSchema = documentStorageSchema.omit({ wormDefaultDays: true });
export const testBackupStorageSchema = z.object({ config: backupStorageSchema.optional() });
/** Intentos de copiar un archivo antes de dejarlo como fallido (se reintenta con espera creciente). */
export const BACKUP_MAX_ATTEMPTS = 8;
/** Horas que puede esperar un archivo sin copiarse antes de que el respaldo se considere atrasado. */
export const BACKUP_LAG_HOURS = 24;
/** Cómo va el respaldo: con fallidos, falla; con algo pendiente hace más de `BACKUP_LAG_HOURS`, va atrasado. */
export function backupHealth(s, now = new Date()) {
    if (s.failed > 0)
        return 'failing';
    if (s.oldestPendingAt && now.getTime() - new Date(s.oldestPendingAt).getTime() > BACKUP_LAG_HOURS * 3_600_000)
        return 'behind';
    return 'ok';
}
//# sourceMappingURL=backup-storage.js.map